import { isDisplayable, isTruthyOrZero } from "util/misc";

// check for 0 demoninator
const safeDivision = (numerator = 0, denominator = 0) => {
  if (!isDisplayable(numerator) || !isDisplayable(denominator)) return;
  return denominator === 0 ? 0 : numerator / denominator;
};

const getPassingCompletionPercentage = (stats) => {
  const { passingCompletions, passingAttempts } = stats;
  if (!isTruthyOrZero(passingAttempts)) return;
  return safeDivision(passingCompletions, passingAttempts);
};

// Yards per pass
const getPassingAverage = (stats) => {
  const { passingYards, passingAttempts } = stats;
  if (!(isTruthyOrZero(passingYards) && isTruthyOrZero(passingAttempts)))
    return;
  return safeDivision(passingYards, passingAttempts);
};

// Yards per rush
const getRushingAverage = (stats) => {
  const { rushingYards, rushingAttempts } = stats;
  if (!(isTruthyOrZero(rushingYards) && isTruthyOrZero(rushingAttempts)))
    return;
  return safeDivision(rushingYards, rushingAttempts);
};

// Yards per catch
const getReceivingAverage = (stats) => {
  const { receivingYards, receptions } = stats;
  if (!(isTruthyOrZero(receivingYards) && isTruthyOrZero(receptions))) return;
  return safeDivision(receivingYards, receptions);
};

const getPuntingAverage = (stats) => {
  const { punts, puntingYards } = stats;
  if (!(isTruthyOrZero(punts) && isTruthyOrZero(puntingYards))) return;
  return safeDivision(puntingYards, punts);
};

export {
  safeDivision,
  getPassingCompletionPercentage,
  getPassingAverage,
  getRushingAverage,
  getReceivingAverage,
  getPuntingAverage
};
